import {CommonModule} from '@angular/common';
import {HostListener, NgModule, OnInit} from '@angular/core';
import {ShareModule} from '@ngx-share/core';
import {SharedModule} from '../../shared/modules/shared.module';
import {BlogDetailNewPageRoutingModule} from './blog-detail-new-page-routing.module';
import {BlogDetailNewPageComponent} from './blog-detail-new-page.component';
import { BlogQuickViewComponent } from '../main-page/blog-quick-view/blog-quick-view.component';

@NgModule({
  declarations: [BlogDetailNewPageComponent],
  imports: [
    CommonModule,
    BlogDetailNewPageRoutingModule,
    SharedModule,
    ShareModule
  ]
})

export class BlogDetailNewPageModule  {

}
